import { render, staticRenderFns } from "./mainView.vue?vue&type=template&id=1c6af210&scoped=true&lang=html&"
import script from "./mainView.vue?vue&type=script&lang=ts&"
export * from "./mainView.vue?vue&type=script&lang=ts&"
import style0 from "./mainView.vue?vue&type=style&index=0&id=1c6af210&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6af210",
  null
  
)

export default component.exports